import styled from 'styled-components';
var AvailabilityItem = styled.li.withConfig({
  displayName: "AvailabilityItemstyles__AvailabilityItem",
  componentId: "ntgjz5-0"
})(["&&{align-items:center;display:flex;line-height:1em;margin-top:7px;margin-right:15px;svg{margin-right:5px;}}"]);
export { AvailabilityItem };